export enum DOCUMENT_EVENT_TYPE {
	View = 0,
	Download = 1,
	ViewDetail = 2,
	Validation = 3,
	CancelValidation = 4,
	Integrated = 5,
}
